import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { OdometerState } from 'remarketing-angular-library';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AdvancedSearchService } from 'src/search/services/advanced-search/advanced-search.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-advanced-search-odometer',
    templateUrl: './advanced-search-odometer.component.html',
    styleUrls: ['./advanced-search-odometer.component.scss'],
    imports: [TranslocoDirective, CommonModule, ReactiveFormsModule]
})
export class AdvancedSearchOdometerComponent implements OnDestroy {
  odometerForm = new UntypedFormGroup({
    min: new UntypedFormControl(),
    max: new UntypedFormControl()
  });

  @Output() closePop = new EventEmitter<string>();

  vm$: Observable<OdometerState>;
  private destroyed$ = new Subject();
  private selectedOdometer$$ = new BehaviorSubject<number>(undefined);

  constructor(private advancedSearchService: AdvancedSearchService) {
    this.vm$ = combineLatest(advancedSearchService.odometerState$, this.selectedOdometer$$).pipe(
      map(([state]) => ({ ...state })),
      tap(state =>
        this.odometerForm.setValue({
          min: state.min || null,
          max: state.max || null
        })
      )
    );
  }

  close() {
    const { min, max } = this.odometerForm.value;
    this.advancedSearchService.setOdometer(+min, +max);
    this.closePop.emit('odometer');
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onInputChange($event) {
    const { min, max } = this.odometerForm.value;
    this.advancedSearchService.setOdometer(+min, +max);
  }
}
